export type MapMode = "square" | "hex";

interface ModeScopedValue {
  mode?: MapMode;
}

interface ModeGridSettings {
  gridSizeWorld: number;
  dungeonGridSizeWorld?: number;
  hexGridSizeWorld?: number;
}

const dungeonOnlyTools = new Set([
  "room", "ellipse", "hexagon", "corridor", "polygon", "erase", "patch",
]);

export const defaultToolForMode = (mode: MapMode) =>
  mode === "hex" ? "terrain" : "room";

export const isToolAvailableInMode = (tool: string, mode: MapMode) => {
  if (mode === "hex") return !dungeonOnlyTools.has(tool);
  return tool !== "terrain";
};

export const objectBelongsToMode = (object: ModeScopedValue, mode: MapMode) =>
  (object.mode ?? mode) === mode;

export const objectsForMode = <T extends ModeScopedValue>(objects: T[], mode: MapMode): T[] =>
  objects.filter((object) => objectBelongsToMode(object, mode));

export const floorForMode = <T>(geometry: T[], mode: MapMode): T[] =>
  mode === "square" ? geometry : [];

export const hexesForMode = <T>(hexCells: T[], mode: MapMode): T[] =>
  mode === "hex" ? hexCells : [];

export const assignMissingObjectModes = <T extends ModeScopedValue>(objects: T[], fallbackMode: MapMode) =>
  objects.map((object) => object.mode ? object : { ...object, mode: fallbackMode });

export const gridSizeForMode = (meta: ModeGridSettings, mode: MapMode) =>
  mode === "hex"
    ? meta.hexGridSizeWorld ?? meta.gridSizeWorld
    : meta.dungeonGridSizeWorld ?? meta.gridSizeWorld;
